import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  inject,
  LOCALE_ID,
  NgModule,
  provideAppInitializer,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { AuthModule } from '@vinnova/auth';
import {
  environment as authInternalEnvironmentToken,
  getMsalGuardConfig,
  getMsalInstance,
  getMsalInterceptorConfig,
  SIGNALR_MAINTENANCE_EVENT,
} from '@vinnova/auth-internal';
import { EadminModule, MAINTENANCE_TYPE } from '@vinnova/e-admin-shell';
import { ETjansterModule } from '@vinnova/e-tjanster';
import {
  FeatureService,
  FeatureTogglingModule,
  initializeFeatures,
} from '@vinnova/feature-toggling';
import { LoggingModule } from '@vinnova/logging';
import { TranslationModule } from '@vinnova/translation';
import { ToastModule } from '@vinnova/ui';
import * as i18nIsoCountries from 'i18n-iso-countries';
import * as en from 'i18n-iso-countries/langs/en.json';
import * as sv from 'i18n-iso-countries/langs/sv.json';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
i18nIsoCountries.registerLocale((sv as any).default);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
i18nIsoCountries.registerLocale(en as any);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutComponent,
    EadminModule.forRoot(environment),
    ETjansterModule.forRoot(environment),
    FeatureTogglingModule.forRoot(environment),
    AuthModule.forRoot(environment, 'utlysningsbyggare'),
    TranslationModule.forRoot(environment),
    LoggingModule.forRoot(environment),
    MsalModule.forRoot(
      getMsalInstance(environment.msalConfig, true),
      getMsalGuardConfig(),
      getMsalInterceptorConfig(
        environment.msalConfig,
        undefined, // resources
        undefined, // extraEndpoints
        [environment.featureUrl],
      ),
    ),
    ToastModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'sv-SE' },
    {
      provide: MAINTENANCE_TYPE,
      useValue: 'Utlysningsbyggare',
    },
    {
      provide: authInternalEnvironmentToken,
      useValue: environment,
    },
    {
      provide: SIGNALR_MAINTENANCE_EVENT,
      useValue: 'maintenanceUtlysningsbyggare',
    },
    provideAppInitializer(() => {
      const initializerFn = initializeFeatures(inject(FeatureService));
      return initializerFn();
    }),
  ],
})
export class AppModule {}
